// This file is automatically generated. Do not edit manually.

import { Customer } from "src/api/generated/erp/db/types/tables/customer";
import { CustomerAddress } from "src/api/generated/erp/db/types/tables/customerAddress";
import { ContactCreateInput } from "src/api/generated/erp/contacts/model/contactCreateInput";
import { CustomerUpdateService_UpdateRequest } from "src/api/generated/erp/sales/customer/service/customerUpdateService";
import { Currency } from "src/api/generated/erp/db/types/tables/currency";
import { CustomerGroup } from "src/api/generated/erp/db/types/tables/customerGroup";
import { CustomerPriceGroup } from "src/api/generated/erp/db/types/tables/customerPriceGroup";
import { DeliveryTerm } from "src/api/generated/erp/db/types/tables/deliveryTerm";
import { EInvoiceOperator } from "src/api/generated/erp/db/types/tables/eInvoiceOperator";
import { PaymentTerm } from "src/api/generated/erp/db/types/tables/paymentTerm";
import { SalespersonView } from "src/api/generated/erp/db/types/tables/salespersonView";
import { TransportRoute } from "src/api/generated/erp/db/types/tables/transportRoute";
import { makeAxiosRequest } from "src/api/utils/apiClient";

export namespace CustomerFormApi {
	export async function getInitData(args: {
		customerId: number | null | undefined;
	}): Promise<CustomerFormApi_InitData> {
		const response = await makeAxiosRequest({
			url: "/api/ext/erp/sales/customer/getInitData",
			method: "POST",
			data: {
				customerId: args.customerId,
			},
		});
		return response as CustomerFormApi_InitData;
	}

	export async function insert(args: {
		customer: Customer;
		deliveryAddress: CustomerAddress;
		invoiceAddress: CustomerAddress;
		contacts?: Array<ContactCreateInput>;
	}): Promise<number> {
		const response = await makeAxiosRequest({
			url: "/api/ext/erp/sales/customer/insert",
			method: "POST",
			data: {
				customer: args.customer,
				deliveryAddress: args.deliveryAddress,
				invoiceAddress: args.invoiceAddress,
				contacts: args.contacts,
			},
		});
		return response as number;
	}

	export async function update(args: { customer: CustomerUpdateService_UpdateRequest }): Promise<void> {
		const response = await makeAxiosRequest({
			url: "/api/ext/erp/sales/customer/update",
			method: "POST",
			data: {
				customer: args.customer,
			},
		});
		return response as void;
	}
}

export interface CustomerFormApi_InitData {
	currencyOptions: Array<Currency>;
	customer: Customer | null | undefined;
	customerGroupOptions: Array<CustomerGroup>;
	customerPriceGroupOptions: Array<CustomerPriceGroup>;
	deliveryAddress: CustomerAddress | null | undefined;
	deliveryTermOptions: Array<DeliveryTerm>;
	eInvoiceOperatorOptions: Array<EInvoiceOperator>;
	invoiceAddress: CustomerAddress | null | undefined;
	paymentTermOptions: Array<PaymentTerm>;
	salespersonOptions: Array<SalespersonView>;
	transportRouteOptions: Array<TransportRoute>;
}
